import React from 'react';
import emaarLogo from '@/assets/images/emaar-logo.svg';

interface BadeelFullLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

export function BadeelFullLogo({ width = 200, height = 120, className = '' }: BadeelFullLogoProps) {
  return (
    <img
      src={emaarLogo}
      alt="Emaar Platform"
      width={width}
      height={height}
      className={className}
    />
  );
}
